import { ActionWindow } from '../../components/action_window/action_window';
import { DESKTOP_PATH, DESKTOP_ARCHIVE_COMPLAINT_CASE_PATH } from '../../constants/paths';
import { desktopAction } from './actions';
import { desktopLoader, Desktop } from './desktop';
import { AuthProvider } from '../../auth_provider';


// Route when authenticated
const desktopRoutes = [
  {
      path: DESKTOP_PATH.slice(1),
      element: <Desktop />,
      loader: desktopLoader,
      shouldRevalidate: ({ nextUrl, actionResult, formMethod }) => { 
        return AuthProvider.is_authenticated && nextUrl.pathname === DESKTOP_PATH && formMethod && (!actionResult || !actionResult.message);
      },
      children: [
        {
          path: `${DESKTOP_ARCHIVE_COMPLAINT_CASE_PATH.slice(1)}:complaint_case_id`,
          element: <ActionWindow
              title="Finalizar caso"
              titleOnLoading="Finalizando caso"
              titleOnFail="Falha ao finalizar caso"
              description="O caso será arquivado e será removido desta lista"
              confirmText="Finalizar"
              onCancelPath={DESKTOP_PATH}
              onFailPath={DESKTOP_PATH}
              onSuccessPath={DESKTOP_PATH}
              submitMethod="POST"
          />,
          action: desktopAction
        }
      ]
  }
];

export { desktopRoutes };